import { useContext } from 'react';
import { store } from 'components/Store';
import LocalStorage from 'utils/LocalStorage';
import { useParams } from 'react-router';

function useGetInitialEmailAddress() {
  const globalState = useContext(store);
  const { state } = globalState;
  const { team } = state;

  const { myself } = team ?? {};
  const params = useParams();
  const { crmEmailId } = params;

  const getInitialSenderEmailAddress = (id, emailAddresses) => {
    if (id === null && !!crmEmailId) {
      return null;
    }
    let defaultCrmEmailAddressId = JSON.parse(LocalStorage.getItem('lastSenderEmailAddress'))?.emailAddressId;
    let userEmail = emailAddresses.find((address) => address.emailAddress?.includes(myself?.emailAddress))?.id;
    let defaultaddresToUse = userEmail ?? defaultCrmEmailAddressId;
    if (userEmail && defaultCrmEmailAddressId && userEmail !== defaultCrmEmailAddressId) {
      defaultaddresToUse = undefined;
    }
    let crmEmailAddressId = id ?? defaultaddresToUse;
    return emailAddresses.find((address) => address.id === crmEmailAddressId);
  };
  return { getInitialSenderEmailAddress };
}

export default useGetInitialEmailAddress;
